module.exports = __webpack_public_path__ + "img/MYS.2fa46cb7.svg";